/* eslint-disable no-plusplus */
import { InertiaProgress } from '@inertiajs/progress';
import Echo from 'laravel-echo';
import { renderToString } from 'react-dom/server';
import { toast } from 'react-toastify';
import resolveConfig from 'tailwindcss/resolveConfig';
import tailwindConfig from '../../tailwind.config';

const fullConfig = resolveConfig(tailwindConfig);

export const __ = (text, replace = {}) => {
  try {
    let translation = text;
    Object.keys(replace).forEach((key) => {
      translation = translation.replace(`:${key}`, replace[key]);
    });
    return translation;
  } catch (e) {
    return text;
  }
};

export const getBreakpointValue = (value) => parseInt(fullConfig.theme.screens[value]?.replace('px', ''), 10) ?? 0;

export const getCurrentBreakpoint = () => {
  let currentBreakpoint = 'xs';
  let biggestBreakpointValue = 0;
  Object.keys(fullConfig.theme.screens).forEach((breakpoint) => {
    const breakpointValue = getBreakpointValue(breakpoint);
    if (
      breakpointValue > biggestBreakpointValue
      && window.innerWidth >= breakpointValue
    ) {
      biggestBreakpointValue = breakpointValue;
      currentBreakpoint = breakpoint;
    }
  });
  return currentBreakpoint;
};

export const getEndPoints = (url) => {
  let isInsideEndPoint = false;
  const agregationWords = [];
  const splitedWords = [];

  const validation = (idx) => {
    if (url.length - 1 === idx) {
      return true;
    }
    if (url[idx + 1] === '/') {
      return true;
    }
    return false;
  };

  for (let i = 0; i < url.length; i++) {
    if (url[i] === '/' && url[i + 1] !== '/') {
      isInsideEndPoint = true;
    }
    if (isInsideEndPoint) {
      splitedWords.push(url[i]);
    }
    if (isInsideEndPoint && validation(i)) {
      const fullWord = splitedWords.join('');
      agregationWords.push(fullWord);
      splitedWords.splice(0, splitedWords.length);
    }
  }
  return agregationWords;
};

export const getScreenList = () => fullConfig.theme.screens;

export function formatPhone(phoneNumber) {
  if (typeof phoneNumber !== 'string') {
    return phoneNumber;
  }

  return phoneNumber
    .replace(/\D/g, '')
    .replace(/^(\d{2})\B/, '($1) ')
    .replace(/(\d{1})?(\d{4})(\d{4})/, '$1$2-$3');
}

export function formatCpfOrCnpj(cpfOrCnpj) {
  if (typeof cpfOrCnpj !== 'string') {
    return cpfOrCnpj;
  }

  if (cpfOrCnpj.length <= 11) {
    return cpfOrCnpj
      .replace(/\D/g, '')
      .replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
  } return cpfOrCnpj
    .replace(/\D/g, '')
    .replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
}

export function getActiveDateParams() {
  const params = new Proxy(new URLSearchParams(window.location.search), {
    get: (searchParams, prop) => searchParams.get(prop),
  });

  const dateFiltered = {};

  const { start_date: startDate, end_date: endDate } = params;

  if (startDate && endDate) {
    const startDateLateOneDay = new Date(startDate);
    const endDateLateOneDay = new Date(endDate);
    dateFiltered.start = new Date(startDateLateOneDay.setDate(startDateLateOneDay.getDate() + 1));
    dateFiltered.end = new Date(endDateLateOneDay.setDate(endDateLateOneDay.getDate() + 1));
    return dateFiltered;
  }
  return null;
}

export const moneyMask = (input) => {
  try {
    let value;
    if (typeof input === 'string') {
      value = parseFloat(String(input || '0').replace('.', '').replace(',', '').replace(/\D/g, '')) / 100;
    }
    if (typeof input === 'number') {
      value = input;
    }

    if (['[object object]', 'undefined'].includes(String(value).toLowerCase())) {
      value = 0;
    }

    const options = { minimumFractionDigits: 2 };
    const formated = new Intl.NumberFormat('pt-BR', options).format(value);

    return { formated, value };
  } catch (error) {
    return {
      formated: '',
      value: 0,
    };
  }
};

export function arraySum(array, iteratee) {
  let result;
  let index = -1;
  const { length } = array;

  // eslint-disable-next-line no-plusplus
  while (++index < length) {
    const current = iteratee(array[index]);
    if (current !== undefined) {
      result = result === undefined ? current : (result + current);
    }
  }
  return result;
}

export function formatCep(cep) {
  if (typeof cep !== 'string') {
    return cep;
  }
  return cep
    .replace(/\D/g, '')
    .replace(/(\d{5})(\d{3})/, '$1-$2');
}

export function init() {
  window.addEventListener('load', () => {
    setTimeout(() => {
      const $rows = document.querySelectorAll('div[role="row"]');
      $rows.forEach((row) => {
        row.addEventListener('click', () => {
          $rows.forEach((r) => {
          // eslint-disable-next-line no-param-reassign
            r.style.backgroundColor = '';
          });
          // eslint-disable-next-line no-param-reassign
          row.style.backgroundColor = '#f5f5f5';
        });
      });
    }, 0);
  });

  try {
    InertiaProgress.init({
      delay: 0,
      color: '#006fb6',
      includeCSS: true,
      showSpinner: true,
    });

    window.Pusher = require('pusher-js');

    window.Echo = new Echo({
      broadcaster: 'pusher',
      key: '85c5fa7f67056bfe91b2',
      cluster: 'mt1',
      forceTLS: true,
    });

    const getMetaAttribute = (attribute) => document.querySelector(`meta[name="${attribute}"]`).getAttribute('content');

    window.getMetaAttribute = getMetaAttribute;
    window.csrfToken  = () => getMetaAttribute('csrf-token');
    window.storageUrl = () => getMetaAttribute('storage-url');
    window.hash = () => (Math.random() * 10).toString(36).substring(2) + Date.now();
    window.serviceKey = (s) => `${s?.type}:${s?.name}:${s?.value}`;
    window.toast = toast;
    window.__ = __;
    window.formatPhone = formatPhone;
    window.formatCpfOrCnpj = formatCpfOrCnpj;
    window.formatCep = formatCep;
    window.moneyMask = moneyMask;
    window.getEndPoints = getEndPoints;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(e);
  }
}

export const setSubfield = (data, field, subfield, value) => ({
  ...data,
  [field]: {
    ...data[field],
    [subfield]: value,
  },
});

export const CreateNodeFromComponent = (component) => {
  const div = document.createElement('div');
  div.innerHTML = renderToString(component);
  return div.firstChild;
};

export const importIcon = (name) => import('react-icons/fa').then((module) => module[name]);

export function parseComponentName(name) {
  if (name.includes('::')) {
    // load from a package
    const [packageName, componentName] = name.split('::');
    return import(
      /* webpackInclude: /\.jsx$/ */
      /* webpackExclude: /node_modules/ */
      /* webpackMode: "lazy" */
      /* webpackPrefetch: true */
      /* webpackPreload: true */
      `../../plugins/${packageName}/resources/Pages/${componentName}`
    )
      .then((module) => module.default);
  }

  // load from the app
  return import(`./Pages/${name}`).then((module) => module.default);
}

export function enhaceGenerator(generator) {
  const iterator = generator();
  iterator.next();
  return iterator;
}

export function enhacePageStateHandler(setPageState) {
  function* handlePageChangeGenerator() {
    const { page } = yield;
    setTimeout(() => {
      setPageState(page);
    }, 0);
  }
  return (state) => {
    const interceptor = enhaceGenerator(handlePageChangeGenerator);
    interceptor.next(state);
  };
}
